import { UserResponseData } from '../user/user';

export interface KeyValue {
    key: string;
    value: string;
}

export interface ObjectBrowserFilterRange {
    value: string | number;
    text: string;
    isDefaultValue?: boolean;
}

export enum ObjectBrowserFilterType {
    SEARCH = 0,
    SELECT = 1,
    TOGGLE = 2,
    AUTOCOMPLETE = 3,
}

export interface ObjectBrowserSelectionTexts {
    showSelectedText?: string;
    showSelectedsText?: string;
    selectedElementsText?: string;
    deleteButtonText?: string;
    clearButtonText?: string;
    createProjectText?: string;
}

export interface ObjectBrowserFilter {
    type?: ObjectBrowserFilterType;
    fieldName?: string;
    queryField?: string;
    placeholder?: string;
    range?: ObjectBrowserFilterRange[];
    text?: string;
    selected?: any;
    value?: any;
    tooltip?: string;
    defaultValue?: any;
    trueValue?: any;
    disable?: boolean;
    disableList?: { field: string; when: boolean }[];
    items?: any[];
    dirtyField?: string;
    width?: string;
    visible?: () => boolean;
    getText?: (item: UserResponseData) => string;
    autocompleteSearchFn?: (value: string) => void;
    filter?: () => boolean;
    hide?: () => boolean;
    onChange?: (value?: ObjectBrowserFilter) => void;
    shownItems?: KeyValue[];
}
